<footer class="app-footer">
  <div class="footer-content">
    <div class="footer-links">
      <a [routerLink]="['/guide']" class="footer-link">Anleitungen</a>
      <span class="separator">|</span>
      <a [routerLink]="['/ueber-mich']" class="footer-link">&Uuml;ber mich</a>
      <span class="separator">|</span>
      <a [routerLink]="['/impressum']" class="footer-link">Impressum</a>
      <span class="separator">|</span>
      <a [routerLink]="['/datenschutz']" class="footer-link">Datenschutz</a>
      <span class="separator">|</span>
      <a [routerLink]="['/agb']" class="footer-link">AGB</a>
      <span class="separator">|</span>
      <a [routerLink]="['/quellangaben']" class="footer-link">Quellangaben</a>
      <span class="separator">|</span>
      <a [routerLink]="['/disclaimer']" class="footer-link">Disclaimer</a>
    </div>
    <div class="footer-copyright">
      <p>&copy; {{ currentYear }} einfachnurlernen.de. Alle Rechte vorbehalten.</p>
    </div>
  </div>
</footer>
